import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function NoteHeader({ icon, label, onClick }) {
  return (
    <>
      <span className="font-weight-bold">Notes</span>
      <div className="text-blue-300 cursor-pointer" onClick={onClick}>
        <FontAwesomeIcon icon={icon} />
        <span className="d-inline-block ml-2 mr-1">{label}</span>
      </div>
    </>
  );
}
